import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { theme } from 'theme';

const useStyles = makeStyles({
  root: {
    marginLeft: ({ margin }) => margin,
  },
});

const OutboundIcon = ({ variant, margin, ...restProps }) => {
  const classes = useStyles({ margin });

  let fill = theme.palette.common.white;
  if (variant === 'dark') {
    fill = theme.palette.primary.main;
  }

  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes.root}
      {...restProps}
    >
      <path
        d="M8.91211 7.33789V10.8379C8.91211 11.002 8.85742 11.1387 8.74805 11.248C8.63867 11.3574 8.50195 11.4121 8.33789 11.4121H1.91211C1.74805 11.4121 1.61133 11.3574 1.50195 11.248C1.39258 11.1387 1.33789 11.002 1.33789 10.8379V4.41211C1.33789 4.24805 1.39258 4.11133 1.50195 4.00195C1.61133 3.89258 1.74805 3.83789 1.91211 3.83789H5.41211C5.57617 3.82878 5.71289 3.76953 5.82227 3.66016C5.94076 3.55078 6 3.41406 6 3.25C6 3.08594 5.94076 2.94922 5.82227 2.83984C5.71289 2.73047 5.57617 2.67122 5.41211 2.66211H1.91211C1.41992 2.68034 1.00977 2.85352 0.681641 3.18164C0.353516 3.50977 0.180339 3.91992 0.162109 4.41211V10.8379C0.180339 11.3301 0.353516 11.7402 0.681641 12.0684C1.00977 12.3965 1.41992 12.5697 1.91211 12.5879H8.33789C8.83008 12.5697 9.24023 12.3965 9.56836 12.0684C9.89648 11.7402 10.0697 11.3301 10.0879 10.8379V7.33789C10.0788 7.17383 10.0195 7.03711 9.91016 6.92773C9.80078 6.80924 9.66406 6.75 9.5 6.75C9.33594 6.75 9.19922 6.80924 9.08984 6.92773C8.98047 7.03711 8.92122 7.17383 8.91211 7.33789ZM10.6621 2.08789V5C10.6712 5.16406 10.7305 5.30078 10.8398 5.41016C10.9492 5.51953 11.0859 5.57422 11.25 5.57422C11.4141 5.57422 11.5508 5.51953 11.6602 5.41016C11.7695 5.30078 11.8288 5.16406 11.8379 5V1.5C11.8288 1.33594 11.7695 1.19922 11.6602 1.08984C11.5508 0.980469 11.4141 0.921224 11.25 0.912109H7.75C7.58594 0.921224 7.44922 0.980469 7.33984 1.08984C7.23047 1.19922 7.17578 1.33594 7.17578 1.5C7.17578 1.66406 7.23047 1.80078 7.33984 1.91016C7.44922 2.01953 7.58594 2.07878 7.75 2.08789H10.6621ZM5.24805 8.32227L11.6602 1.91016C11.7422 1.83724 11.7969 1.75065 11.8242 1.65039C11.8516 1.55013 11.8516 1.44987 11.8242 1.34961C11.7969 1.24023 11.7467 1.14909 11.6738 1.07617C11.6009 1.00326 11.5098 0.953125 11.4004 0.925781C11.3001 0.898438 11.1999 0.898438 11.0996 0.925781C10.9993 0.953125 10.9128 1.00781 10.8398 1.08984L4.42773 7.50195C4.30924 7.62044 4.25 7.75716 4.25 7.91211C4.25911 8.06706 4.31836 8.20378 4.42773 8.32227C4.54622 8.43164 4.68294 8.49089 4.83789 8.5C4.99284 8.5 5.12956 8.44076 5.24805 8.32227Z"
        fill={fill}
      />
    </svg>
  );
};

OutboundIcon.defaultProps = {
  variant: 'light',
  margin: theme.spacing(1.25),
};

OutboundIcon.propTypes = {
  variant: PropTypes.oneOf(['light', 'dark']),
  margin: PropTypes.number,
};

export { OutboundIcon };
